(function() { window.GUID_d84da636_422b_4338_ba72_268048c0e6d8 = { getGuid: function() { return "d84da636-422b-4338-ba72-268048c0e6d8"; } }; })();
var CS;
(function (CS) {
    var Shared;
    (function (Shared) {
        class Section {
            constructor($context) {
                this.$context = $context;
                this.OnBindEvents();
            }
            Dispose() {
            }
            OnBindEvents() {
                var me = this;
            }
        }
        Shared.Section = Section;
    })(Shared = CS.Shared || (CS.Shared = {}));
})(CS || (CS = {}));

//# sourceMappingURL=sections.pre.js.map
